import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ofType, Actions, createEffect } from '@ngrx/effects';

import { tap } from 'rxjs/operators';

import * as ProprietaryFertilizersOverviewActions from './proprietary-fertilizers-overview.actions';

@Injectable()
export class ProprietaryFertilizersOverviewEffects {
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);

  openProprietaryFertilizersOverview$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProprietaryFertilizersOverviewActions.openProprietaryFertilizersOverview),
        tap(() => {
          this.router.navigate(['']);
        }),
      ),
    { dispatch: false },
  );
}
